import React from "react"

const Loader = props => {
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-sm-12">
                    <div role="status" class="ms-2 spinner-border text-dark"><i className="fa fa-spinner me-2 fa-spin"></i></div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Loader
